module.exports = __webpack_public_path__ + "assets/30077a0f754241a34978a756e4fc4b3a.png";